<div>
    <mat-list dense *ngIf="hasUploads">
        <eas-file-upload-control-upload-list-item
            *ngFor="let upload of uploads"
            [isEditable]="!isDisabled"
            [upload]="upload"
            (downloadRequested)="onDownload($event)"
            (previewRequested)="onPreview($event)"
            (removalRequested)="onRemove($event)"
        ></eas-file-upload-control-upload-list-item>
    </mat-list>
    <mat-list *ngIf="!isDisabled" dense [ngStyle]="{'opacity': isUploading || isDisabled ? 0 : 1}">
      <mat-list-item>
        <input #files style="display: none;"
               type="file"
               accept="{{ options.acceptedFileTypes }}"
               [formControl]="filesInputControl"
               (change)="onFileChange($event)"
               [multiple]="options.allowsMultipleUploads" />
        <button mat-stroked-button i18n color="primary"
                type="button"
                [disabled]="isUploading || isDisabled"
                (click)="files.click()" i18n>Choose files</button>
      </mat-list-item>
    </mat-list>
    <ub-alert *ngIf="isUploading" variant="primary" i18n>Your files are uploading, please wait...</ub-alert>
</div>
<ub-button-list content *ngIf="!isDisabled">
  <button mat-button *ngIf="!options.uploadOnSelection"
                     (click)="onUpload()"
                     [disabled]="isUploading" i18n>Upload selected files</button>
  <button mat-button *ngIf="hasFailedUploads"
                     (click)="onRetry()" i18n>Retry upload files</button>
</ub-button-list>
